export interface SearchResultDocument {
  id: string;
  title: string;
  content: string;
  informationTypes_labels?: string[];
  productMetadata_labels?: string[];
  language: string;
  workspaceId: string;
  productId: string;
  revisionId: string;
  cid?: string;
  format: string;
  source: string;
  informationTypes?: string[];
  informationSubjects?: string[];
  documentTypes?: string[];
  productMetadata?: string[];
  components?: string[];
  renditions: Array<{ format: string; source: string }>;
  identities: Array<{ domain: string; identifier: string }>;
  page?: number;
  iri: string;
}

export interface SearchHighlight {
  field: string;
  snippet: string;
}

export interface SearchHit {
  document: SearchResultDocument;
  highlights: SearchHighlight[];
}

export interface GroupedHit {
  groupKey: string;
  found: number;
  hits: SearchHit[];
}

export interface SearchResponse {
  found: number;
  groupedHits: GroupedHit[];
}

/**
 * How the individual filter categories (subjects, components, document types, …)
 * are combined:
 * - `all`: an information unit must match *every* active category (AND);
 * - `any`: an information unit must match *at least one* active category (OR).
 *
 * Within a single category multiple selected values are always combined with OR
 * ("any of these"), regardless of this setting.
 */
export type FilterMatchMode = 'all' | 'any';

export interface SearchParams {
  query: string | null;
  informationTypes?: string[];
  informationSubjects?: string[];
  informationUnits?: string[];
  components?: string[];
  documentTypes?: string[];
  filterMatchMode?: FilterMatchMode;
  limit: number;
  cid?: string;
  language?: string | null;
  groupBy?: string[];
}

export enum SearchMode {
  Typesense = 'typesense',
  Flexsearch = 'flexsearch',
}
